import { ToggleGroup, ToggleGroupItem } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FecThirdPartyFilter } from '../../../../../../enums/fecThirdPartyFilter'
import { isFecThirdPartyFilter } from '../../../../../../utils/isFecThirdPartyFilter'

interface ThirdPartyFilterToggleProps {
  onChange: (filter: FecThirdPartyFilter) => void
  value: FecThirdPartyFilter
}

export const ThirdPartyFilterToggle = ({ onChange, value }: ThirdPartyFilterToggleProps): ReactElement => {
  const { t } = useTranslation()

  const items: ToggleGroupItem[] = useMemo(
    () => [
      {
        label: t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.filter.suppliers'),
        value: FecThirdPartyFilter.Suppliers,
      },
      {
        label: t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.filter.clients'),
        value: FecThirdPartyFilter.Clients,
      },
      {
        label: t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.filter.all'),
        value: FecThirdPartyFilter.All,
      },
    ],
    [t],
  )

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value: selectedValue } = event.currentTarget

      if (isFecThirdPartyFilter(selectedValue)) {
        onChange(selectedValue)
      }
    },
    [onChange],
  )

  return <ToggleGroup items={items} onChange={handleChange} value={value} />
}
